import { Profile } from "../@types/profile";
import AxiosHelper from "../utils/AxiosHelper";
import ApiService from "./ApiService";
import AuthService from "./AuthService";

interface UpdateProfileInput {
  name?: string;
  mobilePhone?: string;
  email?: string;
}

const ProfileService = {
  async getProfile(): Promise<Profile> {
    const response = await ApiService.get("auth/profile");
    return response.data;
  },
  async updateProfile(data: UpdateProfileInput, uuid: string): Promise<void> {
    const token = localStorage.getItem("user-token");

    const config = {
      method: "patch",
      maxBodyLength: Infinity,
      url: process.env.REACT_APP_DELEND_API + "/person-api/v1/person/" + uuid,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    await AxiosHelper.baseQueryWithRefresh(config);
    await AuthService.refreshToken();
  },
  async emailConfirmation(token: string): Promise<void> {
    const config = {
      method: "post",
      url: process.env.REACT_APP_DELEND_API + "/person-api/v1/verify-email",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        token: token,
      },
    };

    await AxiosHelper.baseQueryWithRefresh(config);
  },
  async sendEmailVerification(): Promise<void> {
    const config = {
      method: "post",
      url:
        process.env.REACT_APP_DELEND_API +
        "/person-api/v1/send-verification-email",
      headers: {
        "Content-Type": "application/json",
      },
    };

    await AxiosHelper.baseQueryWithRefresh(config);
  },
};

export default ProfileService;
